import termCategoryQueries from '@apis/queries/termCategoryQueries';
import { TermDisplayContext } from '@models/term/termCategory';
import { useQuery } from '@tanstack/react-query';

function useTermCategories(displayContext: TermDisplayContext) {
    const { data } = useQuery(termCategoryQueries.list(displayContext));
    return data?.categories || [];
}

export default useTermCategories;
